const interfacePhrases = {
    rate_limited: 'Ограничение частоты',
    limit_exceeded: 'Превышение лимита',
    used: 'Использование',
    identifier: 'Идентификатор',
    verification: 'Проверка',
    messages: 'Сообщения',
    data: 'Данные',
    custom: 'Пользовательский',
    management_api: 'API управления {{product}}',
    management_api_role_description: 'Эта встроенная роль предоставляет доступ к API управления.',
    client_credentials: 'Учётные данные клиента',
    authentication_request: 'Запрос аутентификации',
    callback: 'Обратный вызов аутентификации',
    help_title: 'Центр помощи iden',
    help_subtitle: 'Помощь без выхода из рабочего пространства',
    open_help: 'Открыть полную страницу помощи',
    close_help: 'Закрыть помощь',
    about: 'О продукте и открытом ПО',
    open_navigation: 'Открыть навигацию',
    close_navigation: 'Закрыть навигацию',
    development_enabled: 'Функции разработки включены',
    beta: 'Бета',
    impersonation: 'Вход от имени пользователя',
    key: 'Ключ',
    value: 'Значение',
    error: 'Ошибка',
    details: 'Технические подробности',
    callback_failed: 'Не удалось завершить обратный вызов входа.',
    back_sign_in: 'Вернуться ко входу',
    powered_by: 'Работает на',
    avatar: 'Аватар',
    logo: 'Логотип',
    qr_code: 'QR-код',
    sample_title: 'Хотите посмотреть пример?',
    sample_description: 'Изучите пример приложения, использующего это руководство.',
    sample_action: 'Посмотреть пример',
    further_readings: 'Дополнительные материалы',
    complete_guide: 'Полное руководство',
    custom_domains_notice: 'После добавления <a>собственных доменов</a> можно использовать эту конечную точку: <code>{{endpoint}}</code>.',
    my_project: 'Мой проект',
    my_secret: 'Мой секрет',
    my_token: 'Мой токен',
    role_example: 'Читатель',
    reset_retry: 'Сбросить настройки и повторить',
    open_dev_panel: 'Открыть панель разработчика',
    close_dev_panel: 'Закрыть панель разработчика',
    configuration: 'Настройки',
    app_id: 'Идентификатор приложения',
    extra_parameters: 'Дополнительные параметры входа',
    prompt: 'Запрос аутентификации',
    scope: 'Область доступа',
    resource: 'Ресурс',
    resources_space_delimited: 'Ресурсы (через пробел)',
    sign_out_to_apply: 'Выйдите из системы, чтобы применить изменения.',
    refresh_token_grant: 'Авторизация токеном обновления',
    organization_id: 'Идентификатор организации',
    console_result: 'Результат доступен в консоли браузера.',
    request_token: 'Запросить токен',
    user_info: 'Информация о пользователе',
    get_id_token_claims: 'Получить утверждения токена идентификации',
    fetch_user_info: 'Загрузить информацию о пользователе',
    device_initializing: 'Инициализация авторизации устройства…',
    device_success: 'Вы вошли в демонстрационное приложение.',
    sign_in_information: 'Ваши данные входа:',
    email: 'Электронная почта',
    username: 'Имя пользователя',
    user_id: 'Идентификатор пользователя',
    sign_out_demo: 'Выйти из демо',
    device_expired: 'Код устройства истёк',
    generic_error: 'Произошла ошибка',
    device_expired_description: 'Срок действия кода устройства истёк. Повторите попытку, чтобы получить новый код.',
    sign_in_title: 'Войдите в свою учётную запись',
    scan_instruction: 'Отсканируйте QR-код или откройте этот адрес на другом устройстве:',
    one_time_code: 'Введите одноразовый код',
    token_info: 'Информация о токене',
    get_access_token: 'Получить токен доступа',
    context_unavailable: 'Не удалось загрузить данные учётной записи.',
    not_initialized: 'Данные учётной записи не инициализированы.',
    not_set: 'Не задано',
    configured: 'Настроено',
    password: 'Пароль',
    phone: 'Номер телефона',
    search_help: 'Поиск в справке',
    language: 'Язык',
    menu: 'Меню',
    compatibility_notice: 'Совместимость: унаследованные названия SDK, пакетов, протоколов, компонентов и заголовков запросов Logto остаются без изменений.',
    source: 'Источник',
    upstream_repository: 'Исходный репозиторий',
    current_fork: 'Текущий репозиторий',
    license_notice: 'iden основан на Logto — открытом программном обеспечении под лицензией Mozilla Public License 2.0.',
    about_description: 'Информация о продукте и авторстве открытого ПО.',
    page_not_found: 'Страница не найдена',
    page_not_found_description: 'Эта страница недоступна. Вернитесь в центр помощи.',
    introduction: 'Введение',
    quick_starts: 'Быстрый старт',
    integration: 'Интеграция',
    end_user_flows: 'Пользовательские сценарии',
    authorization: 'Авторизация',
    user_management: 'Управление пользователями',
    security: 'Безопасность',
    customization: 'Настройка оформления',
    connectors: 'Коннекторы',
    organizations: 'Организации',
    self_hosting: 'Самостоятельное размещение',
    continue: 'Продолжить',
    loading: 'Загрузка…',
    save: 'Сохранить',
    saved: 'Сохранено',
    try_again: 'Повторить',
    client_id: 'Идентификатор клиента',
    client_secret: 'Секрет клиента',
    redirect_uri: 'URI перенаправления',
    status: 'Статус',
    type: 'Тип',
    permissions: 'Разрешения',
    token_data: 'Данные токена',
    context_data: 'Данные контекста',
    jwt_extra_claims: 'Дополнительные утверждения токена',
    action_result: 'Результат действия',
    social_account_already_linked: 'Этот аккаунт социальной сети уже привязан.',
};
export default Object.freeze(interfacePhrases);
